import script from "./Tiktok.vue?vue&type=script&setup=true&lang=js"
export * from "./Tiktok.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__